/**
 * Утилиты для работы со временем
 */

// Константы времени
export const TIME_CONSTANTS = {
    DEFAULT_START_DELAY: 0.1,
    MIN_START_DELAY: 0.2,
    STABILIZATION_DELAY: 50,
    CLEANUP_INTERVAL: 5,
    MAX_TRAVEL_TIME: 30,
    PAST_TIME_THRESHOLD: 0.1
};

/**
 * Получает безопасное время старта (не в прошлом)
 * @param {number} scheduledTime - запланированное время
 * @param {number} currentTime - текущее время
 * @param {number} minDelay - минимальная задержка
 * @returns {number} скорректированное время
 */
export function getSafeStartTime(scheduledTime, currentTime, minDelay = TIME_CONSTANTS.PAST_TIME_THRESHOLD) {
    return Math.max(scheduledTime, currentTime + minDelay);
}

